import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { defineMessages, useIntl } from "react-intl";

import BillingContactUs from "@app/postBill/components/billingContactUs";
import UPSCreatePaymentMethodContainer from "@app/ups/components/upsCreatePaymentMethodContainer";
import { BlueHeaderContent } from "@app/components/ui/layout";
import { routes } from "@app/routing";

import "./upsCreatePaymentMethod.scss";

const messages = defineMessages({
  upsCreatePaymentTitle: {
    id: "upsCreatePaymentTitle",
    defaultMessage: "Make a payment",
  },
  upsCreatePaymentSubtitle: {
    id: "upsCreatePaymentSubtitle",
    defaultMessage:
      "Select the payment method you want to use. You can also use your FSA or HSA card.",
  },
});

const UPSCreatePaymentMethod: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(routes.upsReviewInvoice, {
      state: { from: routes.upsCreatePaymentMethod },
    });
  };

  return (
    <BlueHeaderContent
      blueHeaderTitle={intl.formatMessage(messages.upsCreatePaymentTitle)}
      backArrowHeaderButton={handleBack}
      noGradient
    >
      <div className="ups-create-payment">
        <div className="ups-create-payment__content">
          <div className="ups-create-payment__subtitle">
            {intl.formatMessage(messages.upsCreatePaymentSubtitle)}
          </div>
          <UPSCreatePaymentMethodContainer />
          <BillingContactUs />
        </div>
      </div>
    </BlueHeaderContent>
  );
};

export default UPSCreatePaymentMethod;
